import api from './apiService';
import dayjs from "dayjs";

export const reportWorkTime = async (params) => {
    try {
        console.warn('###### filtros ##### ', params);

        if (params.startDate) {
            params.startDate = dayjs(params.startDate).format("YYYY-MM-DD HH:mm:ss");
        }
        if (params.endDate) {
            params.endDate = dayjs(params.endDate).format("YYYY-MM-DD HH:mm:ss");
        }
        if (params.users) {
            params.users = params.users.map((user) => user);
        }
        if (params.clients) {
            params.clients = params.clients.map((client) => client);
        }

        const response = await api.post('/reports/tasks', params);

        return response.data; // Retornar a propriedade 'data' da resposta
    } catch (error) {
        throw error.response;
    }
}
